import { authHeader } from '../../_helpers';
import axios from 'axios';

export const getTeamFitmentDataService = {
    getTeamFitmentData,
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')


function getTeamFitmentData(data) {
    return axios.post(`/analytics/analytics_organisation/team/analyse/team_fitment/?access_token=${token}`,data)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/Analyze/teamFitment.service.js